<template>
  <div>
    <div class="cd-actives" v-if="couponList.length || detail.is_vip_course">
      <p>活动：</p>
      <section>
        <div class="actives-item" v-if="couponList.length" @click="getCoupon">
          <span>优惠</span>
          <span>
            <em>领取优惠券最多可减</em>
            <icon-price :priceType="2"></icon-price>
            <i>{{max_price | toFixPrice(0)}}</i>
          </span>
          <font>领取</font>
        </div>
        <div class="actives-item" v-if="detail.is_vip_course" @click="goVip">
          <span>VIP</span>
          <span
            v-if="detail.is_vip_user"
          >您的会员到期日为：{{detail.vip_user_end | fomartTime('yyyy.MM.dd')}}</span>
          <span v-else>免费观看</span>
          <font>{{detail.is_vip_user?'续费':'开通'}}</font>
        </div>
      </section>
    </div>
    <coupon ref="coupon" :couponList="couponList" @setCoupon="setCoupon"></coupon>
  </div>
</template>

<script>
import coupon from "@/components/Coupon";
export default {
  name: "Active",
  components: {
    coupon
  },
  props: {
    couponList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    max_price() {
      if (this.couponList.length) {
        let max_price = 0;
        this.couponList.forEach(item => {
          if (max_price < item.discounted_price) {
            max_price = item.discounted_price;
          }
        });
        return max_price;
      }
    }
  },
  methods: {
    getCoupon() {
      this.$refs.coupon.showModel();
    },
    setCoupon(index) {
      this.$emit("setCoupon", index);
    },
    goVip() {
      this.$router.push({
        name: "Vip"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cd-actives {
  display: flex;
  padding: 30px;
  margin-top: 30px;
  background: #fff;
  p {
    width: 80px;
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(140, 140, 140, 1);
  }
  section {
    flex: 1;
    .actives-item {
      display: flex;
      align-items: center;
      /deep/ .price-ico {
        width: 22px;
        margin-left: 5px;
      }
      &:nth-child(1) {
        padding-bottom: 20px;
      }
      span {
        &:first-child {
          width: 70px;
          height: 32px;
          line-height: 32px;
          background: linear-gradient(
            90deg,
            rgba(206, 184, 156, 1) 0%,
            rgba(163, 130, 89, 1) 100%
          );
          border-radius: 6px;
          font-size: 20px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(38, 38, 38, 1);
          text-align: center;
          margin-right: 14px;
        }
        &:nth-child(2) {
          flex: 1;
          font-size: 24px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(89, 89, 89, 1);
          i {
            color: #ea7a2f;
          }
        }
      }
      font {
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        padding-right: 24px;
        background: url("../../assets/images/icon-go.png") no-repeat right
          center;
        background-size: 16px 28px;
      }
    }
  }
}
</style>
